module.exports = __webpack_public_path__ + "img/ca_success.f7e300dd.png";